module.exports = __webpack_public_path__ + "static/media/NotFound.f7062e93.jpg";